import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { AuthProvider } from './components/AuthContext'; // ⬅️ import it
import './i18n'; // must be before App is rendered

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider> {/* ⬅️ wrap App */}
      <App />
    </AuthProvider>
  </React.StrictMode>
);
